// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__3z1Vy","message":"CookieConsent_message__sBiFM","cookieLink":"CookieConsent_cookieLink__x3hz9","continueBtn":"CookieConsent_continueBtn__1epEp"};